import { render } from "./brokenLineDetails.vue?vue&type=template&id=67047ff4&scoped=true"
import script from "./brokenLineDetails.vue?vue&type=script&lang=js"
export * from "./brokenLineDetails.vue?vue&type=script&lang=js"

import "./brokenLineDetails.vue?vue&type=style&index=0&id=67047ff4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67047ff4"]])

export default __exports__